import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("dr_admin_token") || ""}` },
});

export const api = {
  getProducts: () => axios.get(`${API}/products`).then((r) => r.data.products),
  getProduct: (slug) => axios.get(`${API}/products/${slug}`).then((r) => r.data),
  checkout: (payload) => axios.post(`${API}/checkout`, payload, {
    headers: localStorage.getItem("dr_customer_token")
      ? { Authorization: `Bearer ${localStorage.getItem("dr_customer_token")}` }
      : {},
  }).then((r) => r.data),
  orderBySession: (sessionId) => axios.get(`${API}/orders/by-session/${sessionId}`).then((r) => r.data),
  trackOrder: (orderNumber, email) =>
    axios.get(`${API}/orders/track`, { params: { order_number: orderNumber, email } }).then((r) => r.data),
  contact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
  newsletter: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
  getSettings: () => axios.get(`${API}/settings`).then((r) => r.data),
  joinWaitlist: (email, slug) => axios.post(`${API}/waitlist`, { email, slug, origin: window.location.origin }).then((r) => r.data),

  adminLogin: (email, password) => axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data),
  adminVerify: () => axios.get(`${API}/admin/verify`, authHeaders()).then((r) => r.data),
  adminOrders: () => axios.get(`${API}/admin/orders`, authHeaders()).then((r) => r.data.orders),
  adminPayouts: () => axios.get(`${API}/admin/payouts`, authHeaders()).then((r) => r.data),
  adminLaunch: () => axios.get(`${API}/admin/launch`, authHeaders()).then((r) => r.data),
  adminGetSettings: () => axios.get(`${API}/admin/settings`, authHeaders()).then((r) => r.data),
  adminUpdateSettings: (payload) => axios.put(`${API}/admin/settings`, payload, authHeaders()).then((r) => r.data),
  adminUpdateCredentials: (payload) => axios.put(`${API}/admin/credentials`, payload, authHeaders()).then((r) => r.data),
  adminGoogleSession: (sessionId) => axios.post(`${API}/admin/google-session`, { session_id: sessionId }).then((r) => r.data),
  adminForgotPassword: (email) => axios.post(`${API}/admin/forgot-password`, { email, origin: window.location.origin }).then((r) => r.data),
  adminResetPassword: (token, new_password) => axios.post(`${API}/admin/reset-password`, { token, new_password }).then((r) => r.data),
  adminTeam: () => axios.get(`${API}/admin/team`, authHeaders()).then((r) => r.data.admins),
  adminAddTeamMember: (payload) => axios.post(`${API}/admin/team`, payload, authHeaders()).then((r) => r.data),
  adminRemoveTeamMember: (email) => axios.delete(`${API}/admin/team/${encodeURIComponent(email)}`, authHeaders()).then((r) => r.data),

  customerRegister: (payload) => axios.post(`${API}/auth/register`, payload).then((r) => r.data),
  customerLogin: (payload) => axios.post(`${API}/auth/login`, payload).then((r) => r.data),
  customerMe: () => axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${localStorage.getItem("dr_customer_token") || ""}` } }).then((r) => r.data),
  customerOrders: () => axios.get(`${API}/auth/orders`, { headers: { Authorization: `Bearer ${localStorage.getItem("dr_customer_token") || ""}` } }).then((r) => r.data.orders),
  customerGoogleSession: (sessionId) => axios.post(`${API}/auth/google-session`, { session_id: sessionId }).then((r) => r.data),
  createProduct: (payload) => axios.post(`${API}/admin/products`, payload, authHeaders()).then((r) => r.data),
  updateProduct: (slug, payload) => axios.put(`${API}/admin/products/${slug}`, payload, authHeaders()).then((r) => r.data),
  deleteProduct: (slug) => axios.delete(`${API}/admin/products/${slug}`, authHeaders()).then((r) => r.data),
  uploadImage: (file) => {
    const form = new FormData();
    form.append("file", file);
    return axios.post(`${API}/admin/upload`, form, authHeaders()).then((r) => r.data);
  },
};

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const formatApiError = (e) => {
  const detail = e.response?.data?.detail;
  if (!detail) return e.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
};
